import { VesselCategory } from "../../services/types/position-service.types";
import { Region, PortInfo, TerminalInfo } from "./terminals-model.types";
import { FleetAlarm } from "./voy-fleet-alarm-model.types";
import { IMOsCurrentScheduleState } from "./voyage-schedules-model.types";

export interface VesselInfo {
    imoNo: number;
    vesselName: string;
    vesselClass: string;
    ts: number;
    hasPAPI: boolean;
    ownership?: string | null;
    fg?: string;
    callSign: string;
    ais?: VesselAIS,
    serviceCode: string | null;
    operatorCode: string | null;
    alarms: FleetAlarm[];
    navStatus: string; 
    readingType: string;
    source: string;
    ownershipType?: string;
    vesselCode?: string | null;
    vesselVersion?: string;
    vesselType: string;
    routeType?: string | null;
}

export enum VesselUpdatedEvents {
    AllVessels = "all-vessels",
    Maersk = "maersk"
}

export interface  VesselAIS {
    name: string;
    callSign: string;
    class?:string,
    flag?: string;
    yearBuilt?: number;
    length?: number;
    width?: number;
    regularCapacity?: number;
    operator?: string;
    draught?: number | null;
    navStatus?: string | null;
    dataSource?: string;
    owner?: string;
}

export interface VesselTEUResponse {
    code?: string,
    imo: number,
    mearskOperated?: boolean,
    name: string,
    operatorCode: string,
    teuCapacity?: null|number,
    updatedAt: string

}

export const categories = [ "maersk", "nonMSK", "MSK", "MCC", "SEA", "SGL", "MLL","ALI", "EXT",
"sin1","sin2","cph1","cph2","mum1","mum2","nfk1","stoppage","speed","no-plan","crosstrack","unwn","on-voyage","in-port","NonMSKWithBox","MskUnwn","Basic","Premium","ig"] as const;

export const validOperator = [
   "MSK",
   "MCC",
   "SEA",
   "SGL",
   "MLL",
   "ALI",
   "EXT"
]

export const maerskOwnershipTypes = [
    "BAREBOAT_CHARTER",
    "OWN",
    "TIME_CHARTER"
]

export const nonMaerskWithBox = [
    "FOREIGN_FEEDER",
    "VSA"
]


export interface GlobalSearchsVesselsMetaData  
 {
    vesselName?: string|null,
    vesselClass?: string|null,
    imo?: number,
    vesselDesc?: string | undefined,
    vesselCode?: string | null,
    vesselType?: string,
    vesselVersion?: string;
} 

export interface GlobalSearchsPortsMetaData 
 {
        cityId?: string;
        city?: string;
        terminals?: TerminalInfo[]|[];
        key?:string;
        name?: string;
        locations?: string[];
 }
  
 export interface GlobalSearchsMetaData 
 {
        cityId?: string;
        city?: string;
        terminals?: TerminalInfo[];
        key?:string;
        name?: string;
        locations?: string[];  
        vesselName?: string|null,
        vesselClass?: string|null,
        imo?: number,
        vesselDesc?:string|undefined,
        vesselType?: string
 }
export interface GlobalFilterVesselMetaData {
    alarms?: FleetAlarm[],
    imoNo: number,
    operatorCode: string|null,
    serviceCode: string|null,
    vesselClass: string,
    ownershipType?: string,
    fg?: string,
    source?: string,
    vesselCategory: VesselCategory,
    navStatus?: string,
    routeType?: string|null,
}
export interface GlobalSearchsData {
    maerskVessels: GlobalSearchsVesselsMetaData[],
    nonMaerskVessels: GlobalSearchsVesselsMetaData[],
    searchString: string,
    portsList: PortInfo[],
    portRegions: Region[],
    scheduleStates: IMOsCurrentScheduleState[];
}

export enum OwnerShipType {
    TimeCharter ="TIME_CHARTER"
}
